export default "/assets/images/badge-02.d301ab7923eebb37.webp";